import React from 'react';
import HeaderNavigation from '../../components/ui/HeaderNavigation';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import ExamplesGallery from './components/ExamplesGallery';
import TrustSignals from './components/TrustSignals';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <HeaderNavigation />
      
      <main className="content-wrapper">
        <HeroSection />
        <FeaturesSection />
        <ExamplesGallery />
        <TrustSignals />
        <CTASection />
      </main>

      <Footer />
    </div>
  );
};

export default LandingPage;